import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Rnd } from 'react-rnd';
import CloseIcon from '@material-ui/icons/Close';
import { useChatContext } from '@components/Chat/ChatContextProvider/ChatContextProvider';
import { useChatBuilderConfig } from '@components/Chat/hooks/useChatBuilderConfig/useChatBuilderConfig';
import Loader from '@components/Loaders/Loader/Loader';
import { makeStyles } from '@material-ui/core';
import { useChatPropsAndPosition } from '@components/Chat/hooks/useChatPropsAndPosition/useChatPropsAndPosition';
import { useIsChatEnabled } from '@components/Chat/hooks/useIsChatEnabled/useIsChatEnabled';

const useStyles = makeStyles((theme) => ({
	chatWindow: {
		zIndex: '9999',
		display: 'flex',
		flexDirection: 'column',
		boxSizing: 'border-box',
		boxShadow: '0px 8px 10px -5px rgba(15, 60, 151, 0.20), 0px 16px 24px 2px rgba(15, 60, 151, 0.14), 0px 6px 30px 5px rgba(15, 60, 151, 0.12)',
		borderRadius: '8px',
	},
	dragHandle: {
		cursor: 'move',
		color: theme.palette.common.white,
		background: theme.palette.primary.main,
		padding: theme.spacing(1, 2),
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		height: '40px',
		borderRadius: '8px 8px 0 0',
		marginBottom: '-1px',
	},
	dragHeaderText: {
		fontSize: theme.typography.caption.fontSize,
		fontWeight: 700,
	},
	iframe: {
		width: '100%',
		height: 'calc(100% - 56px)',
		display: 'block',
		boxSizing: 'border-box',
		border: '1px solid',
		borderColor: theme.palette.grey[600],
		borderRadius: '0 0 8px 8px',
		zIndex: 0,
		position:'absolute',
		background: theme.palette.common.white,
	},
	chatLoaderContainer: {
		position: 'relative',
		width: '100%',
		height: '100%',
		boxSizing: 'border-box',
		overflow: 'hidden',
	},
	loader: {
		borderRadius: '0 0 8px 8px',
	},
	closeIcon: {
		cursor: 'pointer',
	},
}));

export const Chat = () => {
	const classes = useStyles();
	const { showChat, toggleShowChat, chatAuthToken, chatUnreadCount } = useChatContext();
	const hasChatConfig = useChatBuilderConfig();
	const { rndProps } = useChatPropsAndPosition();
	const { isChatEnabled } = useIsChatEnabled();

	const showLoader = !hasChatConfig || !chatAuthToken || chatUnreadCount === null;

	if (!isChatEnabled) {
		return null;
	}

	return (
		<Rnd
			{...rndProps}
			className={classes.chatWindow}
			style={{
				position: 'fixed',
				visibility: showChat ? 'visible' : 'hidden',
			}}
		>
			<Box className={`drag-handle ${classes.dragHandle}`}>
				<Typography className={classes.dragHeaderText}>SSM Chat</Typography>
				<CloseIcon
					className={classes.closeIcon}
					onClick={toggleShowChat}
					data-field="app-chatWindow-closeButton"
					aria-label="close chat window"
				/>
			</Box>
			<Box className={classes.chatLoaderContainer}>
				<iframe
					className={classes.iframe}
					src={window.config.CHAT_UI_URL}
					allow="clipboard-write; clipboard-read"
					title="SSM Chat"
				/>
				{showLoader && (
					<Box className={classes.iframe} data-testid="chat-loader">
						<Loader className={classes.loader} />
					</Box>
				)}
			</Box>
		</Rnd>
	);
};
